import * as React from 'react';

import LayerTrigger from 'components/LayerTrigger';
import Tooltip from 'components/Tooltip';

import type { DenialReason } from 'phoneCalls/components/PhoneCallModal';

function getDenialReason(reason: DenialReason, calleeName: string): string | undefined | null {
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | void' is not assignable to type 'st... Remove this comment to see the full error message
  return (
    reason &&
    {
      blocked: 'Unable to receive calls',
      callee_has_multiple_devices: 'Multiple phone numbers on Remind',
      no_callee_phone_on_file: `Add ${calleeName}'s mobile number to Remind`,
      callee_not_in_office: 'Outside office hours',
      callee_under_13: 'Under 13',
      caller_has_multiple_devices: 'Multiple phone numbers on Remind',
      no_caller_phone_on_file: 'Add your mobile number to Remind to start making calls',
      feature_not_available: 'Calling not available',
      two_way_messaging_disabled: 'Unable to receive calls',
      callee_is_remind_bot: 'Unable to receive calls',
      caller_muted: 'Unable to receive calls',
      caller_under_13: 'Under 13',
      group_chat: 'Calling not available',
      self_chat: 'Calling not available',
      chad_chat: 'Calling not available',
      callee_disabled_receiving_phone_calls: `${calleeName} has chosen not to receive calls on Remind.`,
    }[reason]
  );
}

type Props = {
  denialReason: DenialReason;
  calleeName: string;
  children?: React.ReactNode;
};

export class PhoneCallDenialReasonTooltip extends React.Component<Props> {
  render() {
    const { denialReason, children, calleeName } = this.props;
    const denialReasonString = getDenialReason(denialReason, calleeName);
    if (denialReasonString) {
      return (
        <LayerTrigger layer={<Tooltip>{denialReasonString}</Tooltip>} placement="top">
          {children || null}
        </LayerTrigger>
      );
    } else {
      return children || null;
    }
  }
}

export default PhoneCallDenialReasonTooltip;
